
import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import CustomerFundingService from '@/services/customerFunding.service';
import { FormModel } from 'ant-design-vue';

@Component({})
export default class FollowUpModal extends Vue {
  visible = false;

  @Ref()
  formRef!: FormModel;

  title = '客户跟进';

  @Prop({ type: String, default: 'ordinary' })
  type!: string;

  @lazyInject(CustomerFundingService)
  private customerFundingService!: CustomerFundingService;

  form: any = {
    status: '',
    info: '',
    asset_id: '',
  };
  rules = {
    status: [{ required: true, message: '请选择客户意向' }],
  };

  async handleOk() {
    this.formRef.validate(async (valid) => {
      if (valid) {
        const res = await this.customerFundingService.postSimpleAddFollow(this.form);
        if (res) {
          this.$message.success('跟进成功');
          this.visible = false;
          this.$emit('refresh');
        }
      }
    });
  }
  onChangeStatus(e: any) {
    this.form.status = e.target.value;
  }
  init(record: any) {
    this.form = {
      status: '',
      info: '',
      asset_id: '',
    };
    this.visible = true;
    this.form.asset_id = record.id;
  }

  handleCancel() {
    this.visible = false;
  }
}
